<template>
  <div class="md-layout" style="background-color: #f2f2f2">
      <div class="md-layout-item md-size-55 md-small-size-100">
            <div class="item-cert-carboon" style="position: relative;">
              <img alt="Cuadro de detalles" src="@/assets/CUADRO-M-UP.png"  srcset="" class="cuadro-detalles">
              <img alt="Huella de carbono agua" src="@/assets/WATER-FOOTPRINT.png" style="width: 30%; position: absolute; bottom: -5%; left:50%;" />
            </div>
      </div>
      <div class="md-layout-item md-small-size-100 huella-text mt-4">
        <h1 class="gestion-huella" style="font-size: 4vw; text-align: justify; color: #7691b9;">HUELLA DE AGUA</h1>
       <p style="font-weight: bold;">Certificación de Medición Huella del Agua.</p>
        <p>Esta certificación indica que se ha cuantificado los consumos de agua de una organización, producto o servicio. Este es un paso clave en la gestión del recurso hídrico.</p>
        <div style="text-align: left;">
            <md-button class="md-raised md-cert md-elevation-4" style="background-color: #7691b9 !important;" @click="handleClick">
                <img alt="Calendario" src="@/assets/date.svg"  srcset="" width='20px' style="margin-right: 10px; margin-top: -5px" />
               <span>AGENDA UNA REUNIÓN</span> 
                <md-tooltip md-direction="bottom">Agenda una reunión con un ejecutivo</md-tooltip>        
            </md-button>
        </div>
      </div>
      <div style="width: 100%">
          <div class="brouche-carbon md-elevation-20" STYLE="background-color: #7691b9;">
            <a href="/descargar/Brochure-hda.pdf" download="reporte" style="color: #ffff">
                <img alt="Huella de carbono brouche" src="@/assets/huella-carbono-brouche.png"   srcset="" style="position: absolute; left: -15%;top: -60%; width: 15rem;" >
                <h2>HUELLA DE AGUA</h2>
                <h2>DESCARGA NUESTRO BROCHURE</h2>
            </a>
          </div>
      </div>
        <div class="second-section ">
        <h2 class="subtitle slideLeft" >Deja tu Huella</h2>
        <h2 class="subtitle slideRight" style="margin-bottom: -0.4rem; color:#7691b9;">Sin dejar Huella</h2>
        <div class="bakckground-gs">
            <div class="md-layout md-gutter md-alignment-center " style="text-align: justify; width: 95%; margin: auto;" >
            <div class="md-layout-item item-line md-small-size-100 left-side ">

                <div class=" div-circle-container md-layout md-alignment-center slideLeft">
                <div class="md-layout-item md-size-20">
                    <span class="circle" style="background-color: #7691b9;">
                        <img alt="Agua" src="@/assets/mano_water.png"  srcset="">
                    </span>
                </div>
                <div class="md-layout-item md-layout-text">
                    <h2><strong>Declara tu compromiso</strong> <br /> con el medio ambiente</h2>
                </div>
                </div>

                <div class="div-circle-container md-layout md-alignment-center slideLeft">
                <div class="md-layout-item md-size-20">
                    <span class="circle" style="background-color: #7691b9;">
                        <img alt="Enchufe" src="@/assets/enchufewater.png"  srcset="" >
                    </span>
                </div>
                <div class="md-layout-item md-layout-text" >
                    <h2><strong>Identifica alternativas</strong> <br />   de reducción de costo</h2>
                </div>
                </div>

                <div class="div-circle-container md-layout md-alignment-center slideLeft">
                <div class="md-layout-item md-size-20 ">
                    <span class="circle" style="background-color: #7691b9;">
                        <img alt="Agua mundial" src="@/assets/world_water.png"  srcset="">
                    </span>
                </div>
                <div class="md-layout-item md-layout-text" >
                    <h2><strong>Reduce riesgos</strong> <br />   por legislaciones ambientales</h2>
                </div>
                </div>
            </div>

            <div class="md-layout-item item-line md-small-size-100 right-side slideRight" >

                <div class="div-circle-container md-layout md-alignment-center" >
                <div class="md-layout-item md-size-20 ">
                    <span class="circle" style="background-color: #7691b9;">
                        <img alt="Pack" src="@/assets/pack.png"  srcset="">
                    </span>
                </div>
                <div class="md-layout-item md-layout-text">
                    <h2 ><strong>Identifica oportunidades</strong> <br /> de reducción de impactos <br /> ambientales</h2>
                </div>
                </div>

                <div class="div-circle-container md-layout md-alignment-center slideRight">
                <div class="md-layout-item md-size-20 ">
                    <span class="circle" style="margin-top: -1em; background-color: #7691b9;">
                        <img alt="Centro de agua" src="@/assets/heart_water.png"  srcset="" >
                    </span>
                </div>
                <div class="md-layout-item md-layout-text" style="margin-top: -15px;">
                    <h2 ><strong>Se preferido por tus credenciales </strong> <br /> ambientales por consumidores responsables</h2>
                </div>
                </div>

                <div class="div-circle-container md-layout md-alignment-center slideRight" id="circle-last" style="">
                <div class="md-layout-item md-size-20 ">
                    <span class="circle" style="background-color: #7691b9;">
                    <img alt="Agua reciclada" src="@/assets/recycle_water.png"  srcset="">
                    </span>
                </div>
                <div class="md-layout-item md-layout-text" >
                    <h2><strong>Promueve una economía</strong> <br /> sustentable</h2>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        handleClick() {
            gtag( 'event', 'Click',{
                event_category: 'Agendar',
                event_label: 'calendly',
                value: 0
            })
            this.$store.state.showDialog = true
        }
    }

}
</script>

<style>

</style>